import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import userReducer from './user';

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));


const reducers = combineReducers({
    user: userReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'CLEAR_STORE') {
        console.log('clearing data')
        return reducers(undefined, action);
    }

    return reducers(state, action);
};

const store = createStore(rootReducer, composedEnhancer);

export default store;
